import { Card, type CardProps } from "antd";
import { MagicCard } from "components/magicui/magic-card";
import { useReducedMotion } from "motion/react";
import { forwardRef } from "react";

interface SpotlightCardProps extends CardProps {
	gradientSize?: number;
}

// Forwards a DOM ref so overlay triggers (Popover/Tooltip/Dropdown) can
// position against the card without falling back to the deprecated
// `findDOMNode`.
export const SpotlightCard = forwardRef<HTMLDivElement, SpotlightCardProps>(
	function SpotlightCard({ gradientSize = 200, style, ...cardProps }, ref) {
		const reducedMotion = useReducedMotion();

		if (reducedMotion) {
			return <Card ref={ref} {...cardProps} style={style} />;
		}

		return (
			<MagicCard
				ref={ref}
				gradientSize={gradientSize}
				// height/cursor must live on the outer wrapper: the inner Card's
				// height: 100% resolves against it, and the gradient border zone
				// is part of the pointer surface.
				style={{
					borderRadius: 8,
					height: style?.height,
					cursor: style?.cursor,
				}}
			>
				<Card
					{...cardProps}
					variant="borderless"
					style={{ ...style, background: "transparent" }}
				/>
			</MagicCard>
		);
	},
);
